import { OctaneLogger } from '../integrations/datadog/OctaneLogger'
import * as toast from './toast'

function formatValue(value: unknown): string {
    if (Array.isArray(value)) {
        return value.join(', ')
    }

    if (typeof value === 'string') {
        return value
    }

    if (typeof value === 'object' && value !== null) {
        return JSON.stringify(value)
    }

    return JSON.stringify(value)
}

export function formatValidationErrors(
    validationErrors: Record<string, unknown>,
): { errorMessagesForLog: string; fieldNamesForToast: string } {
    const entries = Object.entries(validationErrors)

    const errorMessages = entries
        .map(([key, value]) => `${key}: ${formatValue(value)}`)
        .join('; ')

    const fieldNames = entries.map(([key]) => key).join(', ')

    return {
        errorMessagesForLog: errorMessages,
        fieldNamesForToast: fieldNames,
    }
}

export function handleValidationError(
    validationErrors: Record<string, unknown>,
    formName: string,
): void {
    const formatted = formatValidationErrors(validationErrors)

    OctaneLogger.warn(
        `Validation error in ${formName}: ${formatted.errorMessagesForLog}`,
    )

    toast.error({
        message: `Application could not be submitted. Please check the following fields: ${formatted.fieldNamesForToast}`,
    })
}
